import { Routes, Route, Navigate } from "react-router";
import ListsPage from "./lists/index";
import CampaignsPage from "./campaigns/index";
import EmailAnalyticsPage from "./analytics/index";
import CampaignIntelligencePage from "./campaigns/intelligence";
import CampaignVariantsPage from "./campaigns/variants";
import AbTestingPage from "./campaigns/ab-testing";
import DeliverabilityDashboard from "./deliverability";
import EmailTrackingPage from "./tracking";
import EmailSequencesPage from "./sequences/index";
import EmailTemplatesPage from "./templates";

/**
 * Email Marketing module — B23/B24 enhanced with A/B testing + deliverability.
 */
export default function EmailPage() {
  return (
    <Routes>
      <Route index element={<Navigate to="campaigns" replace />} />
      <Route path="campaigns" element={<CampaignsPage />} />
      <Route path="campaigns/:id/intelligence" element={<CampaignIntelligencePage />} />
      <Route path="campaigns/:id/variants" element={<CampaignVariantsPage />} />
      <Route path="campaigns/:id/ab-test" element={<AbTestingPage />} />
      <Route path="deliverability" element={<DeliverabilityDashboard />} />
      <Route path="tracking" element={<EmailTrackingPage />} />
      <Route path="templates" element={<EmailTemplatesPage />} />
      <Route path="lists" element={<ListsPage />} />
      <Route path="analytics" element={<EmailAnalyticsPage />} />
      <Route path="sequences" element={<EmailSequencesPage />} />
      <Route path="sequences/:sequenceId" element={<EmailSequencesPage />} />
    </Routes>
  );
}
